import { render, staticRenderFns } from "./ListadoRoles.vue?vue&type=template&id=045781e9"
import script from "./ListadoRoles.vue?vue&type=script&lang=js"
export * from "./ListadoRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports